module.exports = __webpack_public_path__ + "img/actualspent-budget.567c0ee1.svg";